import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { Modal, Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const DownloadButtonComponent = ({ data, fileName = 'download.xlsx' }) => {
  const [showModal, setShowModal] = useState(false);

  const handleDownload = () => {
    if (!Array.isArray(data) || data.length === 0 || !data[0] || Object.keys(data[0]).length === 0) {
      setShowModal(true);
      return;
    }

    // ✅ Normalize data: format dates and round floats
    const normalizedData = data.map(row => {
      const newRow = { ...row };
      Object.keys(newRow).forEach(key => {
        const value = newRow[key];

        // Format ISO date strings → "YYYY-MM-DD"
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
          newRow[key] = value.split("T")[0];
        }

        // Round floats → 2 decimals
        else if (typeof value === "number" && !Number.isInteger(value)) {
          newRow[key] = value.toFixed(2);
        }
      });
      return newRow;
    });

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(normalizedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Trigger Excel download
    XLSX.writeFile(workbook, fileName);
  };


  return (
    <>
      <IconButton onClick={handleDownload} style={{ color: 'black' }}>
        <DownloadIcon />
      </IconButton>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Download Unavailable</Modal.Title>
        </Modal.Header>
        <Modal.Body>Data is not available for download at the moment.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DownloadButtonComponent;